/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { useMsal } from "@azure/msal-react";
import { ChangeEvent, useEffect, useState } from "react";
import { Row, ThemeProvider, Form } from "react-bootstrap";
import uuid from "react-uuid";
import { format } from "date-fns";
// import Pagination from "../../components/Pagination";

import { axiosGetRequest, axiosPostRequest } from "../../api/ApiClient";
import Dialog from "../../components/Dialog";
import { DialogConfirm } from "./Components/DialogConfirm";
import ButtonStyles from "../../styles/components/ButtonStyles";
import {
    StyledCardTeacher,
    StyledCardTitle,
} from "../../styles/pages/AcademicActivityPlanStyles";
import {
    StyledBody,
    StyledHeader,
    StyledTitle,
    StyledSubTitle,
    StyledInputGroupSearch,
    StyledInputGroupTextSearch,
    StyledFormControlSearch,
} from "../../styles/MainStyles";
import GenericUtils from "../../utils/GenericUtils";
import UploadFileStyles from "../../styles/pages/UploadFilesStyles";
import { StyledCardGrey } from "../../styles/pages/Schedule/ModalViewDetailsStyles";
import { CalendarIcon, SearchIcon } from "../../components/Icons";
import CheckRadioStyles from "../../styles/components/CheckRadioStyles";
import ModalJustificativa from "./ModalJustificativaI";
import ModalJustificativaD from "./ModalJustificativaD";
import ModalDetalhes from "./ModalDetalhes";
import OvertimeWorkflowDetails, {
    OvertimeDeferralFieldsType,
} from "./OvertimeWorkflowDetails";
import ActionsAbono from "./Components/AbonoActions";
import OvertimeActions, {
    OvertimeWorkflowType,
} from "./Components/OvertimeActions";
import ActivitiesManagementActions, {
    ActivitiesManagementWorkflowType,
} from "./Components/ActivitiesManagementActions";
import ActivitiesManagementModal from "./Components/ActivitiesManagementModal/ActivitiesManagementModal";
import WorkflowItemCard from "./Components/WorkflowItemCard";
import DialogMessage from "../../components/DialogMessage";
import { WorkflowsJustificativaCheckinDTO } from "../../model/dto/WorkflowsJustificativaCheckinDTO";
import {
    StyledCard,
    stylesBox,
    StyledCalendar,
    StyledInputGroupCalendar,
} from "../../styles/pages/GestaoFaltas/GestaoFaltas";
import InputLabelTextArea from "../../components/InputLabelTextArea";

const { StyledImportButton, StyledModalTitle } = UploadFileStyles;
const { DefaultButtonLink, BtnPrimary } = ButtonStyles;

const INDEFERIR = "I";
const DEFERIR = "D";
const WORKFLOW_FILTER_STATUS = "AGUARDANDO_APROVACAO";
const WORKFLOW_APROVED_STATUS = "APROVADO";
const ITEMS_PER_PAGE = 10;
type DateRange = [Date, Date];

type WorkflowType = {
    workflowId: number;
    nome: string;
    ativo: boolean;
    listaUsuariosAprovadores: ListaUsuariosAprovadores[];
};

type ListaUsuariosAprovadores = {
    docenteId: number;
    email: string;
    matricula: string;
    ativo: boolean;
    dataUpdate: string;
    perfis: Perfis[];
};

type Perfis = {
    idPerfil: number;
    nomePerfil: string;
    perfilAtivo: string;
};

const GestaoFaltas: React.FC = () => {
    const ACCESS_TOKEN = GenericUtils.getAccessTokenDocente();
    const [workflowTypes, setWorkflowTypes] = useState<WorkflowType[]>([]);
    const [selectedWorkflowTypeId, setSelectedWorkflowTypeId] =
        useState<number>(-1);
    const [url, setUrl] = useState<string>("");
    const [search, setSearch] = useState<string>("");
    const [activeModal, setActiveModal] = useState<boolean>(false);
    const [showRejectAllowanceModal, setShowRejectAllowanceModal] =
        useState<boolean>(false);
    const [showDeferredAllowanceModal, setShowDeferredAllowanceModal] =
        useState<boolean>(false);
    const [modalEdit, setModalEdit] = useState<boolean>(false);
    const [objectFalta, setObjectFalta] = useState<any>({});
    const [objectSolicitacao, setObjectSolicitacao] = useState<any>({});
    const [status, setStatus] = useState<string>(WORKFLOW_FILTER_STATUS);
    const [modalIndeferir, setModalIndeferir] = useState<boolean>(false);
    const [modalDeferir, setModalDeferir] = useState<boolean>(false);
    const [dateRange, setDateRange] = useState<DateRange>([
        new Date(),
        new Date(),
    ]);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [hasToRefresh, setHasToRefresh] = useState<boolean>(false);
    const [deferButtonClicked, setDeferButtonClicked] =
        useState<boolean>(false);
    const [
        openOvertimeWorkflowDetailsModal,
        setOpenOvertimeWorkflowDetailsModal,
    ] = useState<boolean>(false);
    const [openActivitiesManagementModal, setOpenActivitiesManagementModal] =
        useState<boolean>(false);
    const [workflowDetails, setWorkflowDetails] =
        useState<OvertimeWorkflowType | null>(null);
    const [workflowToDefer, setWorkflowToDefer] =
        useState<OvertimeDeferralFieldsType>({
            details: "",
            guidanceLetter: false,
            modality: "",
            resultCenter: "",
            school: "",
            justification: "",
            campus: "",
        });
    const [workflowActivityManagement, setWorkflowActivityManagement] =
        useState<ActivitiesManagementWorkflowType | null>(null);
    const [
        workflowDeferralConfirmationModalOpen,
        setWorkflowDeferralConfirmationModalOpen,
    ] = useState<boolean>(false);
    const [showWorkflowSuccessModal, setShowWorkflowSuccessModal] =
        useState<boolean>(false);

    const [inEdit, setInEdit] = useState(false);

    const { instance } = useMsal();

    useEffect(() => {
        getAllWorkflowsType();
    }, []);

    const getAllWorkflowsType = async () => {
        const response = await axiosGetRequest(
            "/docente/v1/workflows",
            ACCESS_TOKEN,
            instance
        );

        const workflowTypes = response.data as WorkflowType[];

        if (workflowTypes) {
            const filteredData = workflowTypes.filter(
                (workflow: WorkflowType) => workflow.workflowId !== 1
            );
            setWorkflowTypes(filteredData);
        }
    };

    const handleCloseDialogError = () => {
        setErrorMessage("");
    };

    const handleOpenOvertimeWorkflowDetailsModal = (
        workflow: OvertimeWorkflowType,
        isDetails: boolean
    ) => {
        setDeferButtonClicked(isDetails);
        setOpenOvertimeWorkflowDetailsModal(true);
        setWorkflowDetails(workflow);
    };

    const handleOpenActivitiesManagementModal = (
        workflow: ActivitiesManagementWorkflowType
    ) => {
        setOpenActivitiesManagementModal(true);
        setWorkflowActivityManagement(workflow);
    };

    const handleCloseActivittiesManagementModal = () => {
        setOpenActivitiesManagementModal(false);
        setWorkflowActivityManagement({} as ActivitiesManagementWorkflowType);
    };

    const handleView = async (abonoId: number, inEdite: boolean) => {
        setInEdit(inEdite);
        const response = await axiosGetRequest(
            `docente/v1/workflows/justificativa-checkin/${abonoId}/abono-legal`,
            GenericUtils.getAccessTokenDocente(),
            instance
        );
        if (response.status >= 200 && response.status < 300) {
            setObjectFalta(response.data.dadosWorkflow);
            setObjectSolicitacao(response.data.solicitacaoAbonoLegal);
            setModalEdit(true);
        } else {
            setErrorMessage(response.data?.details);
        }
    };

    const handleSubmit = async (
        justificativa: string,
        // eslint-disable-next-line @typescript-eslint/no-shadow
        status: string,
        solicitacaoAbonoLegal: any
    ) => {
        const response = await axiosPostRequest(
            `docente/v1/workflows/justificativa-checkin/${objectFalta.workflowExecucaoId}/abono-legal`,
            {
                workflowExecucaoId: objectFalta.workflowExecucaoId,
                solicitacaoAbonoLegal,
                justificativa,
                status,
            },
            GenericUtils.getAccessTokenDocente(),
            instance
        );

        if (response.status >= 200 && response.status < 300) {
            if (status === INDEFERIR) {
                setModalIndeferir(false);
                setShowRejectAllowanceModal(true);
                setHasToRefresh(true);
            } else {
                setShowDeferredAllowanceModal(true);
                setHasToRefresh(true);
            }
        } else {
            setErrorMessage(response.data?.details);
        }
    };

    const handleIndeferir = async (justificativa: string) => {
        const resp = await axiosGetRequest(
            `docente/v1/workflows/justificativa-checkin/${objectFalta.workflowExecucaoId}/abono-legal`,
            GenericUtils.getAccessTokenDocente(),
            instance
        );
        await handleSubmit(
            justificativa,
            INDEFERIR,
            resp.data.solicitacaoAbonoLegal
        );
    };

    const handleDeferir = async (justificativa: string) => {
        await handleSubmit(justificativa, DEFERIR, objectFalta);
    };

    const handleDeferOvertimeWorkflow = async () => {
        if (!workflowToDefer || !workflowDetails) {
            return;
        }

        const objectSend = {
            id: workflowDetails?.id,
            created: workflowDetails?.created,
            updated: workflowDetails?.updated,
            cartaoAgendaId: workflowDetails?.cartaoAgendaId,
            nomeDocente: workflowDetails?.nomeDocente,
            matriculaAdp: workflowDetails?.matriculaAdp,
            dtCriacaoCartao: workflowDetails?.dtAlocacaoCartao,
            dtAlocacaoCartao: workflowDetails?.dtAlocacaoCartao,
            nomeAtividade: workflowDetails?.nomeAtividade,
            horaInicio: workflowDetails?.horaInicio,
            horaFim: workflowDetails.horaFim,
            status: "APROVADO",
            cartaOrientacao: workflowToDefer.guidanceLetter,
            campus: workflowToDefer.campus,
            escola: workflowToDefer.school,
            centroResultado: {
                id: Number(workflowToDefer.resultCenter),
            },
            modalidade: {
                modalidadeId: workflowToDefer.modality,
            },
            detalhe: workflowToDefer.details,
            justificativa: workflowToDefer.justification || "",
        };

        const uri = `/docente/v1/workflows/${selectedWorkflowTypeId}/processos`;

        const response = await axiosPostRequest(
            uri,
            objectSend,
            GenericUtils.getAccessTokenDocente(),
            instance
        );

        if (response.status >= 200 && response.status < 300) {
            setWorkflowDeferralConfirmationModalOpen(false);
            setShowWorkflowSuccessModal(true);
            setHasToRefresh(true);
        } else {
            setErrorMessage(response.data?.details);
        }
    };

    const dialogIndeferir = (
        <ModalJustificativa
            open={modalIndeferir}
            onSave={(justificativa: string) => {
                handleIndeferir(justificativa);
            }}
            onClose={() => {
                handleClose();
            }}
        />
    );

    const dialogDeferir = (
        <ModalJustificativaD
            open={modalDeferir}
            onSave={(justificativa: string) => {
                setModalDeferir(false);
                handleDeferir(justificativa);
            }}
            onClose={() => {
                handleClose();
            }}
        />
    );

    const handleClose = () => {
        setActiveModal(false);
        setModalEdit(false);
        setShowRejectAllowanceModal(false);
        setShowDeferredAllowanceModal(false);
        setModalIndeferir(false);
        setModalDeferir(false);
        setOpenOvertimeWorkflowDetailsModal(false);
        setWorkflowDeferralConfirmationModalOpen(false);
        setShowWorkflowSuccessModal(false);
    };

    const handleCloseDeferralModal = () => {
        setWorkflowDeferralConfirmationModalOpen(false);
        setOpenOvertimeWorkflowDetailsModal(true);
    };

    // TODO: Refactor this code to remove inline styles and better reuse of components
    const workflowDeferralConfirmationModal = (
        <Dialog
            openModal={workflowDeferralConfirmationModalOpen}
            onHide={handleClose}
        >
            <StyledModalTitle>Deseja concluir o processo?</StyledModalTitle>
            {GenericUtils.getUser().isDac && (
                <>
                    <p>Insira abaixo a justificativa.</p>
                    <span
                        style={{
                            fontSize: 12,
                            color: "#787878",
                            textAlign: "left",
                            display: "block",
                        }}
                    >
                        Justificativa
                    </span>
                    <InputLabelTextArea
                        value={workflowToDefer.justification || ""}
                        placeholder="Insira sua justificativa"
                        onChange={(event: any) => {
                            if (workflowToDefer) {
                                setWorkflowToDefer({
                                    ...workflowToDefer,
                                    justification: event.target.value || "",
                                });
                            }
                        }}
                        viewLengthInfo
                        maxLength={500}
                        style={{
                            height: "107px",
                            borderStyle: "solid",
                            borderColor: "#787878",
                            width: "100%",
                        }}
                    />
                </>
            )}
            <Row style={{ justifyContent: "center" }}>
                <StyledImportButton
                    style={{ width: 126, marginTop: 24 }}
                    onClick={() => {
                        handleDeferOvertimeWorkflow();
                    }}
                    disabled={
                        GenericUtils.getUser().isDac &&
                        !workflowToDefer.justification
                    }
                >
                    Concluir
                </StyledImportButton>
            </Row>
            <div style={{ height: 15 }} />
            <Row style={{ justifyContent: "center" }}>
                <DefaultButtonLink
                    onClick={() => {
                        handleCloseDeferralModal();
                    }}
                >
                    Cancelar
                </DefaultButtonLink>
            </Row>
        </Dialog>
    );

    const DialogActiveConfirm = (
        <Dialog openModal={activeModal} onHide={handleClose}>
            <StyledModalTitle>Deferir abono legal</StyledModalTitle>

            <Row style={{ justifyContent: "center" }}>
                <StyledImportButton
                    style={{ width: 126, marginTop: 24 }}
                    onClick={() => {
                        handleDeferir("");
                    }}
                >
                    Deferir
                </StyledImportButton>
            </Row>
            <div style={{ height: 15 }} />
            <Row style={{ justifyContent: "center" }}>
                <DefaultButtonLink
                    onClick={() => {
                        handleClose();
                    }}
                >
                    Cancelar
                </DefaultButtonLink>
            </Row>
        </Dialog>
    );

    const DialogError = (
        <DialogMessage
            type="error"
            show={Boolean(errorMessage)}
            title={errorMessage}
            onClose={handleCloseDialogError}
        />
    );

    const dialogDetalhes = (
        <ModalDetalhes
            open={modalEdit}
            onDeferir={(e: any) => {
                setObjectFalta(e);
                setModalEdit(false);
                setModalDeferir(true);
            }}
            onIndeferir={() => {
                setModalEdit(false);
                setModalIndeferir(true);
            }}
            solicitacaoI={objectSolicitacao}
            dadosWorkflowI={objectFalta}
            onClose={() => {
                handleClose();
            }}
            docenteIdI={undefined}
            inEdit={inEdit}
        />
    );

    const handleOvertimeWorkflowDeferral = (
        workflow: OvertimeDeferralFieldsType
    ) => {
        setWorkflowToDefer(workflow);
        setOpenOvertimeWorkflowDetailsModal(false);
        setWorkflowDeferralConfirmationModalOpen(true);
    };

    const overtimeWorkflowDetailsModal = (
        <OvertimeWorkflowDetails
            open={openOvertimeWorkflowDetailsModal}
            workflow={workflowDetails}
            onClose={() => {
                setOpenOvertimeWorkflowDetailsModal(false);
            }}
            onDeferir={handleOvertimeWorkflowDeferral}
            hasToShowFormFields={deferButtonClicked}
        />
    );

    const activitiesManagementModal = (
        <ActivitiesManagementModal
            open={openActivitiesManagementModal}
            workflow={workflowActivityManagement}
            onClose={() => {
                handleCloseActivittiesManagementModal();
            }}
        />
    );

    const handleSearchActivityPlans = (
        event: ChangeEvent<{ value: unknown }>
    ) => {
        setSearch(event.target.value as string);
    };

    const getTipoWorkflow = (): string => {
        const index = workflowTypes.findIndex(
            (workflowType) =>
                workflowType.workflowId.toString() ===
                selectedWorkflowTypeId.toString()
        );

        if (index === -1) {
            return "Workflow desconhecido";
        }

        return workflowTypes[index].nome;
    };

    const renderWorflow = (workflows: any[]) => {
        // MOCK GESTAO ATIVIDADES
        if (selectedWorkflowTypeId.toString() === "3") {
            workflows.push({
                workflowExecucaoId: 99,
                docenteId: 99,
                nomeDocente: "Matheus Santos",
                matriculaDocente: "123456789",
                data: "2023-02-28",
                status: "A",
                workflow: {
                    workflowId: 3,
                    nome: "Gestão de Atividades",
                },
                pendingCheckin: true,
            });
        }

        if (!workflows || workflows.length === 0) {
            return (
                <StyledCard>
                    <StyledCardTitle>
                        Nenhum registro encontrado
                    </StyledCardTitle>
                </StyledCard>
            );
        }

        if (selectedWorkflowTypeId.toString() === "3") {
            return workflows.map(
                (workflow: ActivitiesManagementWorkflowType) => (
                    <WorkflowItemCard
                        workflow={workflow}
                        workflowName={getTipoWorkflow()}
                        key={uuid()}
                    >
                        <ActivitiesManagementActions
                            key={uuid()}
                            workflow={workflow}
                            handleOpenModal={() =>
                                handleOpenActivitiesManagementModal(workflow)
                            }
                        />
                    </WorkflowItemCard>
                )
            );
        }

        // TODO: Deixar o componente generico para que não seja necessário validar o tipo de workflow
        // TODO: Arrumar esse if porque vai quebrar
        if (selectedWorkflowTypeId.toString() === "4") {
            return workflows.map((workflow: OvertimeWorkflowType) => (
                <WorkflowItemCard
                    workflow={workflow}
                    workflowName={getTipoWorkflow()}
                    key={uuid()}
                >
                    <OvertimeActions
                        key={uuid()}
                        workflow={workflow}
                        handleOpenModal={() =>
                            handleOpenOvertimeWorkflowDetailsModal(
                                workflow,
                                false
                            )
                        }
                        handleDefer={() =>
                            handleOpenOvertimeWorkflowDetailsModal(
                                workflow,
                                true
                            )
                        }
                    />
                </WorkflowItemCard>
            ));
        }

        // eslint-disable-next-line @typescript-eslint/no-shadow
        return workflows.map((workflow) => (
            <WorkflowItemCard
                workflow={workflow}
                workflowName={getTipoWorkflow()}
                key={uuid()}
            >
                <ActionsAbono
                    e={workflow}
                    workflowExecucaoId={
                        workflow.workflowExecucaoId
                            ? workflow.workflowExecucaoId.toString()
                            : "1"
                    }
                    handleView={(abonoId) => {
                        handleView(abonoId, false);
                    }}
                    setObjectFalta={(x) => setObjectFalta(x)}
                    setModalIndeferir={(x) => setModalIndeferir(x)}
                    setActiveModal={(_x) => {
                        handleView(
                            workflow.workflowExecucaoId
                                ? workflow.workflowExecucaoId
                                : 1,
                            true
                        );
                    }}
                />
            </WorkflowItemCard>
        ));
    };

    const onChangeWorkflowType = (event: ChangeEvent<{ value: unknown }>) => {
        const workflowTypeId = event.target.value as number;
        setSelectedWorkflowTypeId(workflowTypeId);
        setUrl(
            `docente/v1/workflows/${workflowTypeId}/processos?workflowStatus=${WORKFLOW_FILTER_STATUS.toUpperCase()}&_limit=${ITEMS_PER_PAGE}`
        );
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const handleFilter = () => {
        const initialDate = format(dateRange[0], "yyyy-MM-dd");
        const finalDate = format(dateRange[1], "yyyy-MM-dd");
        const URI = `/docente/v1/workflows/${selectedWorkflowTypeId}/processos?workflowStatus=${status.toUpperCase()}&nomeSolicitante=${search}&dataRange=${initialDate}...${finalDate}&_limit=${ITEMS_PER_PAGE}`;
        setUrl(URI);
        setHasToRefresh(true);
    };

    useEffect(() => {
        setHasToRefresh(!hasToRefresh);
    }, [url]);

    return (
        <ThemeProvider theme={{}}>
            <StyledHeader>
                <StyledTitle>Aprovações</StyledTitle>
                <StyledSubTitle>
                    Nesse espaço você pode editar os colaboradores com permissão
                    para aprovar tarefas
                </StyledSubTitle>
            </StyledHeader>
            <StyledBody>
                <StyledCardGrey body>
                    <Row className="align-items-center">
                        <div style={stylesBox.box3}>
                            <StyledCardTeacher
                                style={{
                                    marginRight: 20,
                                    width: 200,
                                    justifyContent: "center",
                                    paddingTop: 12,
                                }}
                            >
                                Selecione o tipo de workflow
                            </StyledCardTeacher>
                            <Form.Select
                                style={{ width: 200 }}
                                onChange={onChangeWorkflowType}
                                defaultValue={-1}
                            >
                                <option value={-1} disabled>
                                    Selecione o tipo de workflow
                                </option>
                                {workflowTypes.map((workflowType) => (
                                    <option
                                        key={workflowType.workflowId}
                                        value={workflowType.workflowId}
                                    >
                                        {workflowType.nome}
                                    </option>
                                ))}
                            </Form.Select>
                        </div>
                    </Row>
                    <Row style={stylesBox.box1}>
                        <div style={stylesBox.box2}>
                            <StyledCardTeacher
                                style={{ marginRight: 20, marginTop: 20 }}
                            >
                                Filtar
                            </StyledCardTeacher>
                            <CheckRadioStyles.StyledFormCheck
                                inline
                                label="Em andamento"
                                name="group1"
                                type="radio"
                                id="inline-1"
                                style={{ marginTop: 20 }}
                                checked={status === WORKFLOW_FILTER_STATUS}
                                onChange={() => {
                                    setStatus(WORKFLOW_FILTER_STATUS);
                                }}
                            />
                            <CheckRadioStyles.StyledFormCheck
                                inline
                                label="Concluído"
                                name="group1"
                                type="radio"
                                id="inline-2"
                                style={{ marginTop: 20 }}
                                checked={status === WORKFLOW_APROVED_STATUS}
                                onChange={() => {
                                    setStatus(WORKFLOW_APROVED_STATUS);
                                }}
                            />
                            <div
                                style={{
                                    width: 300,
                                    marginTop: 13,
                                }}
                            >
                                <StyledInputGroupCalendar>
                                    <StyledInputGroupTextSearch>
                                        <CalendarIcon
                                            style={{ fill: "#787878" }}
                                        />
                                    </StyledInputGroupTextSearch>
                                    <StyledCalendar
                                        selectionMode="range"
                                        value={dateRange}
                                        dateFormat="dd/mm/yy"
                                        onChange={(e) => {
                                            setDateRange(e.value as DateRange);
                                        }}
                                    />
                                </StyledInputGroupCalendar>
                            </div>
                            <div
                                style={{
                                    width: 350,
                                    marginTop: 13,
                                }}
                            >
                                <StyledInputGroupSearch>
                                    <StyledInputGroupTextSearch>
                                        <SearchIcon />
                                    </StyledInputGroupTextSearch>
                                    <StyledFormControlSearch
                                        type="text"
                                        placeholder="Pesquise aqui"
                                        value={search}
                                        onChange={handleSearchActivityPlans}
                                    />
                                </StyledInputGroupSearch>
                            </div>
                            <div>
                                <BtnPrimary
                                    style={{
                                        width: 126,
                                        marginLeft: 20,
                                        marginTop: 10,
                                    }}
                                    onClick={() => {}}
                                >
                                    Filtrar
                                </BtnPrimary>
                            </div>
                        </div>
                    </Row>
                    <Row
                        style={{
                            paddingTop: 25,
                            paddingLeft: 15,
                            paddingRight: 15,
                        }}
                    >
                        {/* <Pagination<WorkflowsJustificativaCheckinDTO>
                            url={url}
                            renderItems={renderWorflow}
                            accessToken={ACCESS_TOKEN}
                            instance={instance}
                            itemsPerPage={ITEMS_PER_PAGE}
                            selectedType={selectedWorkflowTypeId}
                            hasToRefresh={hasToRefresh}
                        /> */}
                    </Row>
                </StyledCardGrey>
            </StyledBody>
            {DialogActiveConfirm}
            {dialogIndeferir}
            {dialogDeferir}
            {dialogDetalhes}
            {workflowDeferralConfirmationModal}
            {overtimeWorkflowDetailsModal}
            {activitiesManagementModal}
            {errorMessage ? DialogError : null}
            <DialogConfirm
                openModal={showWorkflowSuccessModal}
                handleClose={handleClose}
                modalTitle="Processo concluído"
                acceptButtonText="Ok"
            />
            <DialogConfirm
                openModal={showRejectAllowanceModal}
                handleClose={handleClose}
                modalTitle="Operação realizada com sucesso"
                acceptButtonText="Ok"
            />
            <DialogConfirm
                openModal={showDeferredAllowanceModal}
                handleClose={handleClose}
                modalTitle="Abono Deferido"
                modalText="O professor será avisado que o abono foi deferido. Todas as atividades do período foram abonadas."
                acceptButtonText="Ok"
            />
        </ThemeProvider>
    );
};

export default GestaoFaltas;
